export const getUrlWithoutDomain = (url: string) => {
    try {
        const urlWithoutDomain = new URL(url);
        return urlWithoutDomain.pathname + urlWithoutDomain.search + urlWithoutDomain.hash;
    } catch (_e) {
        // If URL parsing fails, assume it's already a path
        return url;
    }
};
